// API Configuration for the PHP API backend

const API_CONFIG = {
  // API base URL - production server
  BASE_URL: process.env.REACT_APP_API_URL || 'https://demo1.patronservices.in/api',
  UPLOADS_BASE: process.env.REACT_APP_UPLOADS_URL || 'https://demo1.patronservices.in/visitors-uploads',
  LEGACY_UPLOADS_BASE: 'https://ssvassgje.in/build/visitors',
  CMS_BASE_URL: process.env.REACT_APP_CMS_API_URL || 'https://cms.patronservices.in/api/v1',
  CMS_SITE_SLUG: process.env.REACT_APP_CMS_SITE_SLUG || 'ssvassgje-in',
  
  // Timeout in milliseconds
  TIMEOUT: 30000,
  
  // Default headers
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

console.log('API Base URL:', API_CONFIG.BASE_URL);

export default API_CONFIG;
